package io.jsonize.web.services

import kotlinx.browser.document
import org.w3c.dom.HTMLAnchorElement
import org.w3c.dom.url.URL
import org.w3c.files.Blob
import org.w3c.files.BlobPropertyBag

actual class FileExportImpl : FileExport {
    override fun downloadJson(filename: String, content: String) {
        val safeName = ensureJsonFilename(filename)
        val blob = Blob(arrayOf(content), BlobPropertyBag(type = "application/json"))
        val url = URL.createObjectURL(blob)

        val anchor = document.createElement("a") as HTMLAnchorElement
        anchor.href = url
        anchor.download = safeName
        anchor.style.display = "none"
        document.body?.appendChild(anchor)
        anchor.click()
        document.body?.removeChild(anchor)
        URL.revokeObjectURL(url)
    }

    private fun ensureJsonFilename(filename: String): String {
        val trimmed = filename.trim()
        if (trimmed.isEmpty()) return "jsonize.json"
        return if (trimmed.lowercase().endsWith(".json")) trimmed else "$trimmed.json"
    }
}
